<template>
    <div class="exchange-pieces">
        <BaseDialog v-if="!showExchangeSuc" class="exchange-pieces-dialog" button="确定" @close="$emit('close')" @submit="handle_exchange">
            <div slot="title" class="exchange-pieces-head">
                <p>创建我的交换单</p>
            </div>

            <div slot="content" class="exchange-pieces-content">
                <div class="exchange-pieces-layer">
                    <p class="exchange-pieces-layer-title">需要碎片材料</p>
                    <DropdownMenu>
                        <DropdownItem v-model="piecesIdNeed" :options="allPieces" />
                    </DropdownMenu>
                </div>
                <div class="exchange-pieces-layer exchange-pieces-layer1">
                    <p class="exchange-pieces-layer-title">转让碎片材料</p>
                    <DropdownMenu>
                        <DropdownItem v-if="myPieces.length" v-model="piecesIdTransfer" :options="myPieces" />
                        <DropdownItem v-else v-model="piecesIdTransfer" :options="[{ text: '暂无碎片', value: 0 }]" disabled />
                    </DropdownMenu>
                </div>
            </div>
        </BaseDialog>

        <ExchangePiecesSuccess v-if="showExchangeSuc" :url="exchangeSuccessUrl" v-on="$listeners"></ExchangePiecesSuccess>
    </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant';
import { pieceslist, pieces_exchange } from '@/api/preview'
import BaseDialog from '@/components/dialog/baseDialog/baseDialog'
import ExchangePiecesSuccess from '@/components/subscribe/exchange_pieces_success/exchange_pieces_success'
export default {
    components: {
        BaseDialog,
        ExchangePiecesSuccess,
        DropdownMenu,
        DropdownItem,
    },
    data () {
        return {
            piecesIdNeed: 0, // 需要的碎片id
            piecesIdTransfer: 0, // 转让的碎片id
            allPieces: [], // 全部碎片列表

            showExchangeSuc: false, // 展示创建成功弹窗
            exchangeSuccessUrl: '', // 交换单链接
        }
    },
    computed: {
        // 我的碎片列表
        myPieces () {
            return this.allPieces.filter(item => item.num)
        },
    },
    created () {
        this.get_pieceslist()
    },
    methods: {
        // 获取全部碎片列表
        get_pieceslist () {
            pieceslist().then(res => {
                // console.log('res', res.list)
                // 适配 vant下拉菜单组件
                res.list.forEach(item => {
                    item.text = `“${item.piece_name}”碎片`
                    item.value = item.piece_id
                })

                this.allPieces = res.list
            })
        },

        // 创建交换单
        handle_exchange () {
            if (!this.myPieces.length) {
                return this.$toast({
                    type: 'fail',
                    message: '您暂无碎片'
                })
            }
            if (!this.piecesIdNeed) {
                return this.$toast({
                    type: 'fail',
                    message: '请选择需要的碎片'
                })
            }
            if (!this.piecesIdTransfer) {
                return this.$toast({
                    type: 'fail',
                    message: '请选择转让的碎片'
                })
            }

            pieces_exchange({
                piece_id_in: this.piecesIdNeed,
                piece_id_out: this.piecesIdTransfer,
            }).then(res => {
                const query = `transfer_id=${res.transfer_id}&exchangeBy=${this.piecesIdTransfer}&exchangeAfter=${this.piecesIdNeed}`
                this.exchangeSuccessUrl = `${location.href}${location.href.indexOf('?') > -1 ? '&' : '?'}${query}`
                this.showExchangeSuc = true
            })
        },
    },
}
</script>

<style lang="less" scoped>
@import "./exchange_pieces.less";
</style>